import type {
  Event as SentryEvent,
  EventHint as SentryEventHint,
} from "@sentry/types";
import { SentryThrottleRegistry } from "./sentryThrottler.lib";

const THROTTLE_TEN_MINUTES = 10 * 60 * 1000;

export function handleErrorIfPossible(
  event: SentryEvent,
  hint: SentryEventHint
): SentryEvent | null {
  if (isHotReloadingError(event, hint)) {
    return null;
  }

  if (SentryThrottleRegistry.shouldDrop(event, hint)) {
    return null;
  }

  return event;
}

const isPostMessageIOError = (
  _event: SentryEvent,
  hint: SentryEventHint
): hint is { originalException: Error } => {
  return (
    hint.originalException instanceof Error &&
    hint.originalException.name.includes("PostMessageIO")
  );
};

const isHotReloadingError = (_event: SentryEvent, hint: SentryEventHint) => {
  return (
    typeof hint.originalException === "string" &&
    (hint.originalException.includes("[vite] hot updated") ||
      hint.originalException.includes("[vite] invalidate") ||
      hint.originalException.includes("[hmr]"))
  );
};

SentryThrottleRegistry.register({
  matcher: isPostMessageIOError,
  fingerprint: (_event, hint) => {
    if (!(hint.originalException instanceof Error)) {
      return undefined;
    }
    return hint.originalException.name;
  },
  ttlMs: THROTTLE_TEN_MINUTES,
});